export enum PlanState {
  PLAN_STATE_UNSET_TYPE = 'PLAN_STATE_UNSET_TYPE', // Do not use, needed because of proto3 limitations
  PLAN_STATE_QUEUED = 'PLAN_STATE_QUEUED',
  PLAN_STATE_APPLIED = 'PLAN_STATE_APPLIED',
  PLAN_STATE_PREPROVISIONED = 'PLAN_STATE_PREPROVISIONED',
  PLAN_STATE_PAYMENT_ADDED = 'PLAN_STATE_PAYMENT_ADDED', // Apply installment
  PLAN_STATE_NOT_PURCHASABLE = 'PLAN_STATE_NOT_PURCHASABLE',
}
